module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support-group"
  }, [(_vm.showContent) ? _c('div', {
    staticClass: "support-item"
  }, [_c('div', {
    staticClass: "problem-chevron",
    staticStyle: {
      "color": "#0084FF"
    },
    on: {
      "click": function($event) {
        _vm.change_content(1)
      }
    }
  }, [_c('i', {
    staticClass: "ivu-icon ivu-icon-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0 15px 0"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.problem_answer.title))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.problem_answer.content) + "\n            ")])])]) : _c('div', {
    staticClass: "support-item"
  }, _vm._l((_vm.faq), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding": "15px 0 15px 0"
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "support-item-content"
    }, [_vm._v("\n                " + _vm._s(item.content) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "text-primary",
      staticStyle: {
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.fetchContent(item.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('Services_mainpage_remain_to_be_solved')) + " "), _c('Icon', {
      attrs: {
        "type": "chevron-right"
      }
    })], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7526ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/Common/SupportItem.vue
// module id = 810
// module chunks = 0